<template>
  <v-dialog
    v-model="modalVisible"
    :scrollable="scrollable"
    :fullscreen="$vuetify.breakpoint.xsOnly || $attrs.fullscreen"
    :persistent="persistent"
    v-bind="$attrs"
    overlay-opacity="0.8"
  >
    <v-card
      v-bind="cardAttributes"
      class="grey-bg"
    >
      <v-btn
        icon
        large
        absolute
        color="grey lighten-1"
        style="right: 15px; top: 7px"
        @click="!preventClose ? modalVisible = false : $emit('close')"
      >
        <v-icon>
          fal fa-times
        </v-icon>
      </v-btn>
      <v-card-title
        v-if="!$slots.title"
        class="blue-grey lighten-5 px-6 py-4"
      >
        {{ title }}
      </v-card-title>
      <slot
        v-else
        name="title"
      />
      <slot />
      <slot name="actions" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CardDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    cardAttributes: {
      type: Object,
      default: () => ({})
    },
    persistent: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    preventClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
